;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:ENCON_SENTRY_KEY":true});}catch(e){}}();import type React from "react";
import Icon, {type IconName} from "@/components/Icon";
import {CMSLink, type CMSLinkType} from "@/components/Link";

type SocialMediaType = {
	link: CMSLinkType | undefined;
	socialMediaPlatform: IconName;
	square?: boolean;
	outline?: boolean;
};

export const SocialMedia: React.FC<SocialMediaType> = (props) => {
	const { socialMediaPlatform, link } = props;
	return (
		<CMSLink
			{...link}
			label=""
			appearance="inline"
			className="social-media__item"
		>
			{<Icon name={socialMediaPlatform} />}
		</CMSLink>
	);
};
